<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="false"
			@before-close="closeModal"
			:focusTrap="false"
			:adaptive="true"
			height="auto"
			ref="modal"
			:max-width="1400"
			:min-width="1000"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon color="white" class="info-icon mr-2">mdi-list-box-outline</v-icon>
							<div>
								<p class="mb-0 font-weight-bold text-primary title">Tablas de costo relacionadas</p>
							</div>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
					<div v-for="(project_table, index) in projectTables" :key="'project_tables_main-' + index" class="my-2 blocked-content-cost-table">
						<SecondaryTableCost
							:selectedUfValue="selectedUfValue"
							:costs-table="project_table"
							:project="project"
							:contract="contract"
							:colors="colors"
							:colorVars="colorVars"
							:uf-value="ufValue"
							:currency="currency"
							:col-widths="colWidths"
							:can-show-reception-section="canShowReceptionSection"
							:cost_categories_config="cost_categories_config"
						/>
					</div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import SecondaryTableCost from '@/components/Views/Projects/TableCostParts/SecondaryTableCost';

export default {
  name: 'CostBreakdownSecondaryTables',
  components: { SecondaryTableCost },
  data: () => ({
		indexModal: + new Date(),
    validform: true,
		loadingData: false,
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		selectedUfValue(){
			return this.$store.state.costbreakdown.modalProjectTables.selected_uf_value || 'UF'
		},
		project(){
			return this.$store.state.costbreakdown.modalProjectTables.project || {}
		},
		contract(){
			return this.$store.state.costbreakdown.modalProjectTables.contract || {}
		},
		colors(){
			return this.$store.state.costbreakdown.modalProjectTables.colors || {}
		},
		colorVars(){
			return this.$store.state.costbreakdown.modalProjectTables.colorVars || {}
		},
		ufValue(){
			return this.$store.state.costbreakdown.modalProjectTables.ufValue || 0
		},
		currency(){
			return this.$store.state.costbreakdown.modalProjectTables.currency || 'CLP'
		},
		colWidths(){
			return this.$store.state.costbreakdown.modalProjectTables.colWidths || {}
		},
		canShowReceptionSection(){
			return this.$store.state.costbreakdown.modalProjectTables.canShowReceptionSection || false
		},
		cost_categories_config(){
			return this.$store.state.costbreakdown.modalProjectTables.cost_categories_config || {}
		},
		projectTables(){
			console.log('projectTables', this.$store.state.costbreakdown.modalProjectTables)
			return this.$store.state.costbreakdown.modalProjectTables.project_tables || []
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
  mounted(){
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  methods: {
		closeModal(){
			this.$store.commit('costbreakdown/setShowModalProjectTables', false)
			this.$store.commit('costbreakdown/setModalProjectTables', null)
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
	.blocked-content-cost-table {
		pointer-events: none;
		opacity: 0.6;
	}
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>
<style>
	.modal-drag-custom-drag{
		pointer-events: none !important;
	}
	.modal-drag-custom-drag .vm--modal{
		pointer-events: all !important;
	}
	.modal-drag-custom-drag .vm--overlay {
		display: none;
	}
</style>